import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import {Select,FormControl} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import PublicIcon from '@material-ui/icons/Public';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  platformSelect: {

    '& .MuiSelect-select:focus': {
      backgroundColor: 'white'
    },

    '& .MuiSelect-select': {
      maxWidth: 24
    },
    // maxWidth:24,
    '& svg.MuiSvgIcon-root.MuiSelect-icon': {
      background: 'white'
    }
  },
  icon: {
    marginRight: theme.spacing(0.5)
  }
}));

const PlatformSelect = ({ value, setValue }) => {
  const classes = useStyles();

  return (
    <FormControl>
      <Select
        // native
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        variant="standard"
        defaultValue="Facebook"
        className={classes.platformSelect}
      >
        <MenuItem value="Facebook">
          <FacebookIcon className={classes.icon} /> Facebook
        </MenuItem>
        <MenuItem value="Instagram">
          <InstagramIcon className={classes.icon} /> Instagram
        </MenuItem>
        <MenuItem value="Others">
          <PublicIcon className={classes.icon} /> Others
        </MenuItem>
      </Select>
    </FormControl>
  );
};


export default PlatformSelect;